module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zbjy-box"
  }, [(_vm.data) ? _c('div', {
    staticClass: "zbjy-content"
  }, [_c('div', {
    staticClass: "zbjy-info-card"
  }, [_c('div', {
    staticClass: "zbjy-info-left"
  }, [_c('span', {
    staticClass: "zbjy-info-room"
  }, [_vm._v(_vm._s(_vm.data.liveName))]), _vm._v(" "), _c('span', {
    staticClass: "zbjy-info-time"
  }, [_vm._v(_vm._s(_vm.$t('all.keyongshiduan')) + "：" + _vm._s(_vm.data.liveDate) + " " + _vm._s(_vm.data.liveTime))])]), _vm._v(" "), _c('span', {
    staticClass: "zbjy-info-tag"
  }, [_vm._v(_vm._s(_vm.$t('all.youxiao')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbjy-type-row"
  }, [_c('div', {
    class: _vm.data.liveType === 1 ? 'zbjy-type-active' : 'zbjy-type'
  }, [_vm._v(_vm._s(_vm.$t('all.shoujizhibo')))]), _vm._v(" "), _c('div', {
    class: _vm.data.liveType === 2 ? 'zbjy-type-active' : 'zbjy-type'
  }, [_vm._v("OBS" + _vm._s(_vm.$t('all.zhibo')))])]), _vm._v(" "), (_vm.data.liveType === 2) ? _c('div', {
    staticClass: "zbjy-item"
  }, [_c('span', {
    staticClass: "zbjy-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.tuiliudizhi')))]), _vm._v(" "), _c('span', {
    staticClass: "zbjy-item-value zbjy-text-green"
  }, [_vm._v(_vm._s(_vm.data.obsUrl))])]) : _vm._e(), _vm._v(" "), (_vm.data.liveType === 2) ? _c('div', {
    staticClass: "zbjy-item"
  }, [_c('span', {
    staticClass: "zbjy-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.tuiliumamiyao')))]), _vm._v(" "), _c('span', {
    staticClass: "zbjy-item-value zbjy-text-green zbjy-text-wrap"
  }, [_vm._v(_vm._s(_vm.data.obsCode))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zbjy-item"
  }, [_c('span', {
    staticClass: "zbjy-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojinyao')))]), _vm._v(" "), _c('span', {
    staticClass: "zbjy-item-value zbjy-text-green"
  }, [_vm._v(_vm._s(_vm.data.startKey))])]), _vm._v(" "), _c('div', {
    staticClass: "zbjy-item2 zbjy-item-mail"
  }, [_c('div', {
    staticClass: "zbjy-item-mail-left"
  }, [_c('span', {
    staticClass: "zbjy-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.youjiankuaidi')))]), _vm._v(" "), _c('span', {
    staticClass: "zbjy-info-tag zbjy-info-tag-click",
    on: {
      "click": _vm.handleGoMail
    }
  }, [_vm._v(_vm._s(_vm.$t('all.yifasong')))])]), _vm._v(" "), _c('span', {
    staticClass: "zbjy-item-desc"
  }, [_vm._v(_vm._s(_vm.data.emailInfo.content))])]), _vm._v(" "), _c('div', {
    staticClass: "zbjy-btn",
    on: {
      "click": _vm.handleCopyAll
    }
  }, [_vm._v(_vm._s(_vm.$t('all.fuzhiquanbu')))])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showToast) ? _c('div', {
    staticClass: "zbjy-toast"
  }, [_vm._v(_vm._s(_vm.$t('all.fuzhichenggong')))]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d667eec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/zhibojinyao/zhibojinyao.vue
// module id = 979
// module chunks = 1